(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('AppAttestLogDialogController', AppAttestLogDialogController);

    AppAttestLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'AppAttestLog'];

    function AppAttestLogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, AppAttestLog) {
        var vm = this;

        vm.appAttestLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.appAttestLog.id !== null) {
                AppAttestLog.update(vm.appAttestLog, onSaveSuccess, onSaveError);
            } else {
                AppAttestLog.save(vm.appAttestLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:appAttestLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setPublicKeyData = function ($file, appAttestLog) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        appAttestLog.publicKeyData = base64Data;
                        appAttestLog.publicKeyDataContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
